import { render, staticRenderFns } from "./BaseTab.vue?vue&type=template&id=036bb47e&scoped=true&"
import script from "./BaseTab.vue?vue&type=script&lang=js&"
export * from "./BaseTab.vue?vue&type=script&lang=js&"
import style0 from "./BaseTab.vue?vue&type=style&index=0&id=036bb47e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "036bb47e",
  null
  
)

export default component.exports